import { z } from "zod";

export const apiCacheSchema = z.object({
  input: z.string(),
  output: z.string(),
});

export type APICache = z.infer<typeof apiCacheSchema>;
